import { useLazyUser } from "$global-providers/user-provider";
import getSupportedLanguage from "$routes/_lib/get-supported-language";
import { USER_LANGUAGE_CODES } from "$routes/_lib/i18n-constants";
import React from "react";

// TODO: this default language could be set on a territory basis using config
export const DEFAULT_LANGUAGE = USER_LANGUAGE_CODES.ENGLISH;

export function getBrowserLanguage() {
  return (
    getSupportedLanguage(window.navigator.languages) ||
    getSupportedLanguage(window.navigator.language) ||
    DEFAULT_LANGUAGE
  );
}
const useUserLanguage = () => {
  const userLang = useLazyUser()?.language;

  return React.useMemo(
    () => getSupportedLanguage(userLang) || getBrowserLanguage(),
    [userLang],
  );
};

export default useUserLanguage;
